module.exports = __webpack_public_path__ + "img/newsimg.bc27c5f0.jpg";